export type TokenMode =
  | { kind: 'queryParam' }
  | { kind: 'brandLocked'; fallbackSession: string }
  | { kind: 'brandFallback'; fallbackSession: string };

export function resolveTokenMode(
  fallbackSession: string | undefined,
  allowQueryParam: boolean
): TokenMode {
  if (!fallbackSession) return { kind: 'queryParam' };
  return allowQueryParam
    ? { kind: 'brandFallback', fallbackSession }
    : { kind: 'brandLocked', fallbackSession };
}
